<template>
    <div
        data-cy="notifications"
        class="text-gray-700"
    >
        <slot />
        <div
            v-if="loading"
            class="py-10 flex items-center justify-center"
        >
            <UILoading class="w-12 h-12" />
        </div>
        <div
            v-else-if="error"
            class="p-4"
        >
            <Error
                :axios-error="error"
            />
        </div>
        <ModuleComponents
            v-else-if="component"
            :modules="[component]"
        />
    </div>
</template>

<script setup>
    import ModuleComponents from '@/components/ModuleComponents.vue'
    import { disableAutomaticRightIconKey } from '@/keys'
    import Error from '@/components/ui/Error.vue'

    const pushNotifications = usePushNotifications()
    const notificationsStore = useNotificationsStore()

    provide(disableAutomaticRightIconKey, true)

    const { component, loading, error } = storeToRefs(notificationsStore)

    const pushNotificationReceived = (notification) => {
        // Clear out of notifications
        notificationsStore.lastFetched = null
        notificationsStore.fetch()
    }

    onMounted(() => {
        pushNotifications.events.on('pushNotificationReceived', pushNotificationReceived)
    })

    onUnmounted(() => {
        pushNotifications.events.off('pushNotificationReceived', pushNotificationReceived)
    })
</script>
